import { useState } from "react"

const STATUS_STYLES = {
  running: { bg:"#dcfce7", color:"#16a34a", label:"Đang chạy" },
  stopped: { bg:"#fee2e2", color:"#dc2626", label:"Dừng"      },
  standby: { bg:"#fef9c3", color:"#92400e", label:"Dự phòng"  },
  ok:      { bg:"#f1f5f9", color:"#64748b", label:"OK"        },
}

// ─── PX Hồ Quang — Thiết bị ──────────────────────────────

const PXHQ_DATA = [
  // Lò hồ quang EAF
  { id:"HQ.EAF.LHQ1",  name:"Lò hồ quang điện 30 tấn số 1 (EAF-1)",     type:"Lò EAF",       qty:1, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.EAF.LHQ2",  name:"Lò hồ quang điện 30 tấn số 2 (EAF-2)",     type:"Lò EAF",       qty:1, since:"03/2016", status:"stopped", alarm:false },
  { id:"HQ.EAF.MBA1",  name:"Máy biến áp lò EAF-1 (25 MVA, 35kV/0.5kV)",type:"Điện",         qty:1, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.EAF.MBA2",  name:"Máy biến áp lò EAF-2 (25 MVA, 35kV/0.5kV)",type:"Điện",         qty:1, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.EAF.HEC1",  name:"Điện cực graphite EAF-1 (Ø 400mm)",         type:"Điện cực",     qty:3, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.EAF.HEC2",  name:"Điện cực graphite EAF-2 (Ø 400mm)",         type:"Điện cực",     qty:3, since:"03/2016", status:"stopped", alarm:false },
  { id:"HQ.EAF.BAMS1", name:"Bộ điều chỉnh tự động cực EAF-1 (ARM)",     type:"Điện",         qty:1, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.EAF.BAMS2", name:"Bộ điều chỉnh tự động cực EAF-2 (ARM)",     type:"Điện",         qty:1, since:"03/2016", status:"ok",      alarm:false },
  // Vỏ & nắp lò
  { id:"HQ.VL.VLHQ1",  name:"Vỏ lò EAF-1 (shell)",                       type:"Cơ khí",       qty:1, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.VL.NLLHQ1", name:"Nắp lò & nắp tháo điện cực EAF-1",         type:"Cơ khí",       qty:1, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.VL.XITT1",  name:"Xi tháo thép đáy lệch EAF-1",               type:"Cơ khí",       qty:1, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.VL.XIXI1",  name:"Xi tháo xỉ EAF-1",                          type:"Cơ khí",       qty:1, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.VL.MNGC1",  name:"Mâm nghiêng lò EAF-1 (hydraulic tilting)",  type:"Cơ khí",       qty:1, since:"03/2016", status:"ok",      alarm:false },
  // Phun vật liệu
  { id:"HQ.PVL.PTHK",  name:"Hệ thống phun than, vôi, O₂ qua cửa lò",  type:"Khác",         qty:1, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.PVL.BVLO2", name:"Bơm vật liệu phun O₂ (lance O₂ 2 000 Nm³/h)",type:"Bơm",       qty:2, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.PVL.BVLC",  name:"Bơm vật liệu phun than (carbon injection)", type:"Bơm",          qty:2, since:"03/2016", status:"ok",      alarm:false },
  // Làm mát nước
  { id:"HQ.NC.BNNC1",  name:"Bơm nước làm mát vỏ & nắp lò EAF-1",       type:"Bơm",          qty:3, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.NC.BNNC2",  name:"Bơm nước làm mát vỏ & nắp lò EAF-2",       type:"Bơm",          qty:3, since:"03/2016", status:"standby", alarm:false },
  { id:"HQ.NC.TLNC",   name:"Tháp làm nguội nước tuần hoàn EAF",          type:"Khác",         qty:2, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.NC.BNTH",   name:"Bơm nước tuần hoàn EAF",                    type:"Bơm",          qty:4, since:"03/2016", status:"running", alarm:false },
  // Hệ thống khói & lọc bụi
  { id:"HQ.LD.QGKK",   name:"Quạt gió hút khói chính EAF (350 000 Nm³/h)",type:"Máy",         qty:2, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.LD.LBTE",   name:"Lọc bụi túi vải EAF (bag filter)",          type:"Khác",         qty:1, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.LD.CTLB",   name:"Cầu trục thu hồi bụi lò EAF",               type:"Thiết bị nâng",qty:1, since:"03/2016", status:"ok",      alarm:false },
  // Tiếp liệu phế
  { id:"HQ.TL.CTPH1",  name:"Cầu trục phế liệu 16 tấn số 1",            type:"Thiết bị nâng",qty:1, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.TL.CTPH2",  name:"Cầu trục phế liệu 16 tấn số 2",            type:"Thiết bị nâng",qty:1, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.TL.BXTH",   name:"Bàn xe thùng thép/thùng xỉ",                type:"Khác",         qty:4, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.TL.HDOP",   name:"Hệ thống đổ vật liệu thùng tải (charging)",  type:"Khác",         qty:2, since:"03/2016", status:"ok",      alarm:false },
  // Hệ thống biến tần & điều khiển
  { id:"HQ.DK.SVC1",   name:"Bộ bù công suất SVC/STATCOM EAF-1",         type:"Điện",         qty:1, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.DK.SVC2",   name:"Bộ bù công suất SVC/STATCOM EAF-2",         type:"Điện",         qty:1, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.DK.PLC1",   name:"PLC điều khiển EAF-1 (Siemens S7-400)",     type:"Điện",         qty:1, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.DK.PLC2",   name:"PLC điều khiển EAF-2 (Siemens S7-400)",     type:"Điện",         qty:1, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.DK.HMI1",   name:"HMI vận hành lò EAF-1",                     type:"Điện",         qty:2, since:"03/2016", status:"running", alarm:false },
  { id:"HQ.DK.HMI2",   name:"HMI vận hành lò EAF-2",                     type:"Điện",         qty:2, since:"03/2016", status:"ok",      alarm:false },
  { id:"HQ.DK.SCADA",  name:"SCADA giám sát xưởng hồ quang",             type:"Điện",         qty:1, since:"03/2016", status:"running", alarm:true  },
  { id:"HQ.DK.04KV",   name:"Hệ thống điện 0.4kV xưởng hồ quang",       type:"Điện",         qty:1, since:"03/2016", status:"ok",      alarm:false },
]

// ─── Vận Hành Lò Hồ Quang ────────────────────────────────

const EAF_FURNACES = [
  {
    id:"EAF-1", label:"Lò EAF-1", active:true, phase:"Nấu chảy",
    power:18.4, setPoint:20.0, voltage:485, current:21.8,
    steelTemp:1580, targetTemp:1620, heatN:142,
    o2Flow:1850, carbonInj:28, limePowder:180,
    coolWaterIn:28, coolWaterOut:42, waterFlow:320,
    elecConsume:6.8, tapWeight:29.2, slag:3.1,
    electrodePos:[82, 80, 83], electrodeDiam:400,
    color:"#ef4444",alarm:false
  },
  {
    id:"EAF-2", label:"Lò EAF-2", active:false, phase:"Dừng",
    power:0, setPoint:20.0, voltage:0, current:0,
    steelTemp:null, targetTemp:1620, heatN:141,
    o2Flow:0, carbonInj:0, limePowder:0,
    coolWaterIn:28, coolWaterOut:28, waterFlow:0,
    elecConsume:0, tapWeight:null, slag:null,
    electrodePos:[100, 100, 100], electrodeDiam:400,
    color:"#94a3b8", alarm:false
  },
]

const EAF_HEATS_LOG = [
  { heat:142, eaf:"EAF-1", charge:29.8, power:18.4, time:"42:18", elec:6.8, o2:1850, carbon:28, lime:180, steelT:1580, tapT:1618, yield:96.8, grade:"SAE1008", alarm:false },
  { heat:141, eaf:"EAF-1", charge:30.1, power:19.2, time:"44:05", elec:7.1, o2:1920, carbon:31, lime:195, steelT:null,  tapT:1622, yield:97.1, grade:"SAE1010", alarm:false },
  { heat:140, eaf:"EAF-2", charge:29.5, power:18.8, time:"43:30", elec:6.9, o2:1870, carbon:29, lime:185, steelT:null,  tapT:1615, yield:96.5, grade:"SAE1008", alarm:false },
  { heat:139, eaf:"EAF-1", charge:30.0, power:20.1, time:"45:12", elec:7.4, o2:1980, carbon:33, lime:200, steelT:null,  tapT:1630, yield:97.3, grade:"CT3",     alarm:true  },
  { heat:138, eaf:"EAF-2", charge:28.9, power:17.9, time:"41:55", elec:6.5, o2:1820, carbon:26, lime:175, steelT:null,  tapT:1608, yield:96.2, grade:"SAE1008", alarm:false },
]

// ── EAF cross-section SVG ──
function EAFSvg({ active=true, phase="Nấu chảy", electrodePos=[82,80,83], w=140, h=170 }) {
  const cx  = w/2
  const meltY = h*0.72
  const c   = "#1e3a5f"
  const ep  = electrodePos.map(p => h*0.06 + (p/100)*(h*0.55))
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      {/* Shell */}
      <path d={`M ${cx-42},${h*0.18} L ${cx+42},${h*0.18}
        L ${cx+46},${h*0.50} L ${cx+38},${h*0.82}
        L ${cx-38},${h*0.82} L ${cx-46},${h*0.50} Z`}
        fill="white" stroke={c} strokeWidth={1.5}/>
      {/* Refractory lining */}
      <path d={`M ${cx-34},${h*0.20} L ${cx+34},${h*0.20}
        L ${cx+38},${h*0.50} L ${cx+30},${h*0.78}
        L ${cx-30},${h*0.78} L ${cx-38},${h*0.50} Z`}
        fill={active?"#fef2f2":"#f8fafc"} stroke={active?"#fca5a5":"#e2e8f0"} strokeWidth={1}/>
      {/* Melt pool */}
      <ellipse cx={cx} cy={meltY} rx={28} ry={10}
        fill={active?"#fbbf24":"#cbd5e1"} opacity={0.9}/>
      {active&&<>
        <ellipse cx={cx} cy={meltY-5} rx={18} ry={7} fill="#f97316" opacity={0.6}/>
        <ellipse cx={cx} cy={meltY-9} rx={10} ry={4} fill="white" opacity={0.4}/>
      </>}
      {/* 3 electrodes */}
      {[cx-16, cx, cx+16].map((ex, i) => (
        <g key={i}>
          <rect x={ex-3} y={0} width={6} height={ep[i]} rx={2}
            fill={active?"#374151":"#94a3b8"} opacity={0.9}/>
          {active&&<ellipse cx={ex} cy={ep[i]+3} rx={4} ry={3}
            fill="#fbbf24" opacity={0.8}/>}
          {active&&<ellipse cx={ex} cy={ep[i]+1} rx={2} ry={2}
            fill="white" opacity={0.6}/>}
        </g>
      ))}
      {/* Roof */}
      <path d={`M ${cx-44},${h*0.18} Q ${cx},${h*0.04} ${cx+44},${h*0.18}`}
        fill="white" stroke={c} strokeWidth={1.5}/>
      {/* Electrode openings in roof */}
      {[cx-16, cx, cx+16].map((ex,i)=>(
        <ellipse key={i} cx={ex} cy={h*0.13} rx={4} ry={2}
          fill="#f1f5f9" stroke={c} strokeWidth={0.8}/>
      ))}
      {/* Tap hole */}
      <rect x={cx+28} y={h*0.72} width={12} height={5} rx={1}
        fill={active?"#f97316":"#94a3b8"} opacity={0.8}/>
      {/* Slag door */}
      <rect x={cx-40} y={h*0.62} width={8} height={10} rx={2}
        fill="#64748b" opacity={0.6}/>
      {/* Phase label */}
      <text x={cx} y={h*0.96} textAnchor="middle" fontSize={9} fontWeight="700"
        fill={active?"#ef4444":"#94a3b8"}>{active?phase:"Dừng"}</text>
      {/* Heat arc lines */}
      {active&&[cx-16, cx, cx+16].map((ex,i)=>(
        <line key={i} x1={ex} y1={ep[i]} x2={ex+(i-1)*3} y2={meltY-10}
          stroke="#fbbf24" strokeWidth={1} opacity={0.4} strokeDasharray="3 2"/>
      ))}
    </svg>
  )
}

function VanHanhHoQuangView() {
  const [selFurnace, setSelFurnace] = useState(EAF_FURNACES[0])
  const [hovId,      setHovId]      = useState(null)

  const totalPower  = EAF_FURNACES.filter(f=>f.active).reduce((s,f)=>s+f.power,0)
  const alarmsN     = EAF_FURNACES.filter(f=>f.alarm).length
  const activeN     = EAF_FURNACES.filter(f=>f.active).length

  const HPipe = ({color="#22c55e",active=true,width=24,flow=null,unit=""}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{width,height:3,background:active?color:"#e2e8f0",borderRadius:2,
        opacity:active?1:0.5,boxShadow:active?`0 0 4px ${color}66`:"none"}}/>
      {flow!=null&&<span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} {unit}</span>}
    </div>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":"◀"}</span>
  )
  const ColHeader = ({title,count=null,extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title}{count!=null&&<span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}> ({count})</span>}
      </span>
      {extra||<div/>}
    </div>
  )

  // ── Furnace card — MachineCard pattern ──
  const FurnaceCard = ({f}) => {
    const isSel = selFurnace?.id===f.id
    const isHov = hovId===f.id
    const pct   = f.active ? Math.min((f.power/f.setPoint)*100,100) : 0
    return (
      <div onClick={()=>setSelFurnace(f)}
        onMouseEnter={()=>setHovId(f.id)} onMouseLeave={()=>setHovId(null)}
        style={{
          background:"white",
          border:`2px solid ${isSel?"#2563eb":f.alarm?"#fca5a5":"#e2e8f0"}`,
          borderRadius:8,padding:"12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:f.active?1:0.6
        }}>
        {/* Header */}
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
          <div style={{width:34,height:34,borderRadius:6,
            background:f.active?"#fef2f2":"#f1f5f9",
            display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:18,flexShrink:0}}>{f.active?"🔥":"○"}</div>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{f.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>Mẻ #{f.heatN}</div>
          </div>
          <span style={{fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:8,
            background:f.active?"#fee2e2":"#f1f5f9",
            color:f.active?"#dc2626":"#64748b"}}>
            {f.active?f.phase:"Dừng"}</span>
        </div>
        {/* EAF SVG */}
        <div style={{display:"flex",justifyContent:"center",marginBottom:10}}>
          <EAFSvg active={f.active} phase={f.phase} electrodePos={f.electrodePos} w={130} h={155}/>
        </div>
        {/* Power + temp */}
        <div style={{display:"flex",gap:10,marginBottom:8}}>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Công suất</div>
            <div style={{fontSize:20,fontWeight:900,color:f.active?"#ef4444":"#94a3b8",
              lineHeight:1,fontFamily:"monospace"}}>
              {f.power}<span style={{fontSize:10,fontWeight:400,color:"#94a3b8",marginLeft:2}}>MW</span>
            </div>
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>T° thép</div>
            <div style={{fontSize:14,fontWeight:700,color:"#f97316",lineHeight:1,fontFamily:"monospace"}}>
              {f.steelTemp??<span style={{color:"#94a3b8"}}>—</span>}
              <span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>°C</span>
            </div>
            <div style={{fontSize:8,color:"#64748b"}}>Mục tiêu: {f.targetTemp}°C</div>
          </div>
        </div>
        {/* Power bar */}
        <div style={{height:5,background:"#f1f5f9",borderRadius:3,overflow:"hidden",marginBottom:6}}>
          <div style={{height:"100%",borderRadius:3,width:`${pct}%`,
            background:pct>95?"#ef4444":pct>80?"#f59e0b":"#22c55e",transition:"width .3s"}}/>
        </div>
        {/* Injection params */}
        {f.active&&(
          <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
            {[
              {k:"O₂",  v:`${f.o2Flow} Nm³/h`, c:"#ef4444"},
              {k:"C",   v:`${f.carbonInj} kg/min`,c:"#374151"},
              {k:"Vôi", v:`${f.limePowder} kg`, c:"#64748b"},
            ].map(r=>(
              <div key={r.k} style={{
                background:"#f8fafc",border:"1px solid #e2e8f0",
                borderRadius:4,padding:"2px 6px",fontSize:8
              }}>
                <span style={{color:"#94a3b8"}}>{r.k}: </span>
                <span style={{color:r.c,fontWeight:700,fontFamily:"monospace"}}>{r.v}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }

  // ── Param card — inline stat row ──
  const ParamCard = ({title, rows}) => (
    <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
      padding:"10px 12px",marginBottom:8,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
      <div style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,
        textTransform:"uppercase",marginBottom:6}}>{title}</div>
      {rows.map(r=>(
        <div key={r.k} style={{display:"flex",justifyContent:"space-between",
          alignItems:"center",padding:"4px 0",borderBottom:"1px solid #f8fafc"}}>
          <span style={{fontSize:9,color:"#64748b"}}>{r.k}</span>
          <span style={{fontSize:r.big?16:12,fontWeight:r.big?900:700,
            color:r.alarm?"#ef4444":r.c||"#374151",fontFamily:"monospace"}}>
            {r.v}<span style={{fontSize:8,fontWeight:400,color:"#94a3b8",marginLeft:2}}>{r.u||""}</span>
          </span>
        </div>
      ))}
    </div>
  )

  // ── Output card (canonical) ──
  const OutputCard = ({item}) => {
    const isHov = hovId===item.id
    return (
      <div onMouseEnter={()=>setHovId(item.id)} onMouseLeave={()=>setHovId(null)}
        style={{background:"white",border:`2px solid ${item.active?"#e2e8f0":"#f1f5f9"}`,
          borderRadius:8,padding:"10px 12px",marginBottom:8,
          boxShadow:isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:item.active?1:0.55}}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <span style={{fontSize:16}}>{item.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <Arrow color={item.color} active={item.active} dir="left"/>
          <HPipe color={item.color} active={item.active} width={10}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white"
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.active?item.color:"#e2e8f0"} opacity={0.25}/>
            <circle cx={7} cy={9} r={1.5} fill={item.active?item.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9} stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white"
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <HPipe color={item.color} active={item.active} width={8}/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:13,fontWeight:800,color:item.active?item.color:"#94a3b8",
              fontFamily:"monospace"}}>{item.val}</span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
          </div>
        </div>
      </div>
    )
  }

  const sf = selFurnace

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Lò đang hoạt động", value:`${activeN}/${EAF_FURNACES.length}`, icon:"🔥", color:"#ef4444"},
            {label:"Tổng công suất",    value:`${totalPower.toFixed(1)} MW`,       icon:"⚡", color:"#f59e0b"},
            {label:"Mẻ lò EAF-1",      value:`#${EAF_FURNACES[0].heatN}`,         icon:"🪣", color:"#2563eb"},
            {label:"T° thép EAF-1",    value:`${EAF_FURNACES[0].steelTemp}°C`,    icon:"🌡", color:"#f97316"},
            {label:"O₂ phun",          value:`${EAF_FURNACES[0].o2Flow} Nm³/h`,   icon:"🔴", color:"#ef4444"},
            {label:"Cảnh báo",         value:`${alarmsN}`,                         icon:"⚠",  color:alarmsN>0?"#ef4444":"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:90,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:13,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* 3 columns */}
        <div style={{display:"flex",gap:0,minWidth:620}}>

          {/* COL 1: Furnace cards */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",paddingRight:12,minWidth:180}}>
            <ColHeader title="Lò hồ quang" count={EAF_FURNACES.length}/>
            {EAF_FURNACES.map(f=><FurnaceCard key={f.id} f={f}/>)}
          </div>

          {/* COL 2: Selected furnace detail params */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",padding:"0 12px",minWidth:190}}>
            <ColHeader title={sf?sf.label:"Thông số"} extra={
              sf&&<span style={{fontSize:9,fontWeight:700,
                background:sf.active?"#fee2e2":"#f1f5f9",
                color:sf.active?"#dc2626":"#64748b",
                padding:"2px 8px",borderRadius:8}}>
                {sf.active?sf.phase:"Dừng"}</span>
            }/>

            <ParamCard title="Điện" rows={[
              {k:"Công suất TT",   v:sf?.power??0,   u:"MW",  c:"#ef4444", big:true},
              {k:"Cài đặt",        v:sf?.setPoint??0,u:"MW",  c:"#64748b"},
              {k:"Điện áp",        v:sf?.voltage??0, u:"V",   c:"#f59e0b"},
              {k:"Dòng điện",      v:sf?.current??0, u:"kA",  c:"#f59e0b"},
              {k:"Tiêu thụ",       v:sf?.elecConsume??0,u:"MWh",c:"#94a3b8"},
            ]}/>

            <ParamCard title="Thép & Xỉ" rows={[
              {k:"T° thép TT",    v:sf?.steelTemp??"—",   u:"°C", c:"#f97316", big:true},
              {k:"Mục tiêu T°",   v:sf?.targetTemp??0,    u:"°C", c:"#64748b"},
              {k:"Khối lượng tháo",v:sf?.tapWeight??"—",  u:"T",  c:"#22c55e"},
              {k:"Xỉ",            v:sf?.slag??"—",         u:"T",  c:"#94a3b8"},
            ]}/>

            <ParamCard title="Phun vật liệu" rows={[
              {k:"O₂ phun",    v:sf?.o2Flow??0,      u:"Nm³/h",c:"#ef4444"},
              {k:"Phun than",  v:sf?.carbonInj??0,   u:"kg/min",c:"#374151"},
              {k:"Vôi bột",    v:sf?.limePowder??0,  u:"kg",   c:"#64748b"},
            ]}/>

            <ParamCard title="Nước làm mát" rows={[
              {k:"T° nước vào",  v:sf?.coolWaterIn??0, u:"°C",   c:"#0ea5e9"},
              {k:"T° nước ra",   v:sf?.coolWaterOut??0,u:"°C",
                c:(sf?.coolWaterOut??0)>45?"#ef4444":"#f59e0b",
                alarm:(sf?.coolWaterOut??0)>45},
              {k:"Lưu lượng",    v:sf?.waterFlow??0,  u:"m³/h",  c:"#0ea5e9"},
            ]}/>
          </div>

          {/* COL 3: Outputs + heat log */}
          <div style={{flex:1,paddingLeft:12,minWidth:170}}>
            <div style={{display:"flex",alignItems:"center",marginBottom:12}}>
              <Arrow color="#f97316" active={true} dir="left"/>
              <HPipe color="#f97316" active={true} width={12}/>
              <div style={{flex:1}}><ColHeader title="Đầu ra" count={3}/></div>
            </div>
            {[
              {id:"OUT-ST",  label:"Thép lỏng → LF",    icon:"🔥", val:sf?.tapWeight??"—", unit:"T",   color:"#f97316", active:!!sf?.active},
              {id:"OUT-SL",  label:"Xỉ lỏng",            icon:"🌋", val:sf?.slag??"—",      unit:"T",   color:"#94a3b8", active:!!sf?.active},
              {id:"OUT-GS",  label:"Khói → Lọc bụi",    icon:"🌫", val:"350 000",            unit:"Nm³/h",color:"#64748b",active:!!sf?.active},
            ].map(o=><OutputCard key={o.id} item={o}/>)}

            {/* Heat log mini */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",marginTop:4,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Lịch sử mẻ gần nhất
              </div>
              {EAF_HEATS_LOG.slice(0,5).map((h,i)=>(
                <div key={h.heat} style={{
                  display:"flex",alignItems:"center",justifyContent:"space-between",
                  padding:"5px 0",borderBottom:i<4?"1px solid #f8fafc":"none"
                }}>
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <span style={{
                      fontSize:9,fontWeight:700,color:"white",
                      background:h.alarm?"#ef4444":"#2563eb",
                      padding:"1px 5px",borderRadius:5,fontFamily:"monospace"
                    }}>#{h.heat}</span>
                    <span style={{fontSize:9,color:"#64748b"}}>{h.eaf}</span>
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{fontSize:9,fontFamily:"monospace",color:"#f97316",fontWeight:700}}>
                      {h.tapT}°C
                    </span>
                    <span style={{fontSize:8,fontFamily:"monospace",color:"#22c55e"}}>
                      {h.yield}%
                    </span>
                    <span style={{
                      fontSize:8,fontWeight:700,
                      background:h.grade.startsWith("SAE")?"#ede9fe":"#f0fdf4",
                      color:h.grade.startsWith("SAE")?"#7c3aed":"#16a34a",
                      padding:"1px 5px",borderRadius:4
                    }}>{h.grade}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Detail panel */}
      <div style={{width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"}}>
        {!selFurnace ? (
          <div style={{height:"100%",display:"flex",flexDirection:"column",alignItems:"center",
            justifyContent:"center",color:"#94a3b8",padding:20,textAlign:"center",gap:8}}>
            <span style={{fontSize:32}}>🔥</span>
            <span style={{fontWeight:600,color:"#64748b",fontSize:12}}>Chọn lò EAF</span>
          </div>
        ) : (()=>{
          const f = selFurnace
          const trend = Array.from({length:18},(_,i)=>
            f.active ? 40+Math.abs(Math.sin(i/3))*45+(Math.random()-.5)*8 : 5
          )
          return (
            <div>
              <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
                display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{f.id} · </span>
                  <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{f.label}</span>
                </div>
                <span style={{fontSize:9,fontWeight:600,padding:"2px 7px",borderRadius:8,
                  background:f.active?"#fee2e2":"#f1f5f9",color:f.active?"#dc2626":"#64748b"}}>
                  {f.active?f.phase:"Dừng"}</span>
              </div>
              <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
                {["Thông tin","Lịch sử"].map((t,i)=>(
                  <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
                    fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
                    borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"}}>{t}</button>
                ))}
              </div>
              <div style={{padding:"12px",background:"white",borderBottom:"1px solid #f1f5f9",
                display:"flex",justifyContent:"center"}}>
                <EAFSvg active={f.active} phase={f.phase} electrodePos={f.electrodePos} w={120} h={140}/>
              </div>
              {[
                ["Công suất",    `${f.power} MW`],
                ["Điện áp",      `${f.voltage} V`],
                ["Dòng điện",    `${f.current} kA`],
                ["T° thép",      f.steelTemp?`${f.steelTemp}°C`:"—"],
                ["O₂ phun",      `${f.o2Flow} Nm³/h`],
                ["Mẻ số",        `#${f.heatN}`],
              ].map(([k,v])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",
                  padding:"6px 14px",borderBottom:"1px solid #f8fafc"}}>
                  <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
                  <span style={{fontSize:11,fontWeight:600,color:"#0f172a"}}>{v}</span>
                </div>
              ))}
              <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
                color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>CÔNG SUẤT 1H QUA</div>
              <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
                <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
                  {trend.map((v,i)=>(
                    <div key={i} style={{flex:1,height:`${v}%`,background:"#ef4444",
                      borderRadius:"1px 1px 0 0",opacity:0.8}}/>
                  ))}
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
                  <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
                  <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
                </div>
              </div>
            </div>
          )
        })()}
      </div>
    </div>
  )
}

// ─── PXHQPanel ────────────────────────────────────────────

function PXHQPanel() {
  const [pxhqSubTab,   setPxhqSubTab]   = useState("Vận Hành Lò Hồ Quang")
  const [search,       setSearch]       = useState("")
  const [filterType,   setFilterType]   = useState("Tous")
  const [alarmOnly,    setAlarmOnly]    = useState(false)
  const [viewMode,     setViewMode]     = useState("table")
  const [selectedItem, setSelectedItem] = useState(null)

  const types   = ["Tous", ...Array.from(new Set(PXHQ_DATA.map(d=>d.type)))]
  const filtered = PXHQ_DATA.filter(d => {
    if (alarmOnly && !d.alarm) return false
    if (filterType !== "Tous" && d.type !== filterType) return false
    if (search && !d.name.toLowerCase().includes(search.toLowerCase()) &&
                  !d.id.toLowerCase().includes(search.toLowerCase())) return false
    return true
  })

  return (
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:"#f8fafc"}}>
      <div style={{background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"0 16px",display:"flex",alignItems:"center",gap:4,flexShrink:0}}>
        {["Thiết bị","Vận Hành Lò Hồ Quang"].map(t=>(
          <button key={t} onClick={()=>setPxhqSubTab(t)} style={{
            padding:"10px 16px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
            background:"transparent",
            color:pxhqSubTab===t?"#1e3a5f":"#64748b",
            borderBottom:pxhqSubTab===t?"2px solid #1e3a5f":"2px solid transparent",
            transition:"all .15s",whiteSpace:"nowrap"
          }}>{t}</button>
        ))}
      </div>

      {pxhqSubTab==="Vận Hành Lò Hồ Quang" ? <VanHanhHoQuangView/> : (
      <>
      <div style={{background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"10px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0,flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:6,background:"#f8fafc",
          border:"1px solid #e2e8f0",borderRadius:6,padding:"5px 10px",minWidth:180}}>
          <span style={{color:"#94a3b8",fontSize:13}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Tìm kiếm..."
            style={{border:"none",outline:"none",background:"transparent",fontSize:12,color:"#374151",width:140}}/>
        </div>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {types.map(t=>(
            <button key={t} onClick={()=>setFilterType(t)} style={{
              padding:"4px 10px",border:"none",borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
              background:filterType===t?"#2563eb":"#f1f5f9",
              color:filterType===t?"white":"#64748b",transition:"all .15s"
            }}>{t}</button>
          ))}
        </div>
        <button onClick={()=>setAlarmOnly(p=>!p)} style={{
          padding:"4px 10px",border:`1px solid ${alarmOnly?"#ef4444":"#e2e8f0"}`,
          borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
          background:alarmOnly?"#fee2e2":"white",color:alarmOnly?"#ef4444":"#64748b",transition:"all .15s"
        }}>⚠ Chỉ cảnh báo</button>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#94a3b8"}}>{filtered.length} thiết bị</span>
        <div style={{display:"flex",gap:2}}>
          {["table","grid"].map(m=>(
            <button key={m} onClick={()=>setViewMode(m)} style={{
              padding:"5px 8px",border:"none",borderRadius:5,cursor:"pointer",
              background:viewMode===m?"#2563eb":"#f1f5f9",
              color:viewMode===m?"white":"#64748b",fontSize:13,transition:"all .15s"
            }}>{m==="table"?"≡":"⊞"}</button>
          ))}
        </div>
      </div>

      <div style={{flex:1,display:"flex",overflow:"hidden"}}>
        <div style={{flex:1,overflow:"auto"}}>
          {viewMode==="table" ? (
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                  {["ID","Tên thiết bị","Loại","SL","Ngày SD","Trạng thái","Cảnh báo"].map(h=>(
                    <th key={h} style={{padding:"8px 12px",textAlign:"left",fontWeight:600,color:"#64748b",fontSize:11,whiteSpace:"nowrap"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(item=>{
                  const ss=STATUS_STYLES[item.status]||STATUS_STYLES.ok
                  const sel=selectedItem?.id===item.id
                  return (
                    <tr key={item.id} onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                      style={{background:sel?"#eff6ff":item.alarm?"#fff7f7":"white",borderBottom:"1px solid #f1f5f9",cursor:"pointer"}}>
                      <td style={{padding:"8px 12px",fontFamily:"monospace",color:"#64748b",fontSize:11}}>{item.id}</td>
                      <td style={{padding:"8px 12px",fontWeight:600,color:"#0f172a",maxWidth:300}}>{item.name}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap"}}>{item.type}</td>
                      <td style={{padding:"8px 12px",textAlign:"center",fontWeight:700,color:"#374151"}}>{item.qty}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap",fontSize:11}}>{item.since}</td>
                      <td style={{padding:"8px 12px"}}><span style={{background:ss.bg,color:ss.color,padding:"2px 8px",borderRadius:8,fontSize:10,fontWeight:600}}>{ss.label}</span></td>
                      <td style={{padding:"8px 12px",textAlign:"center"}}>
                        {item.alarm?<span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"white",fontWeight:900}}>!</span>:<span style={{color:"#22c55e",fontSize:14}}>✓</span>}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          ) : (
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:10,padding:14}}>
              {filtered.map(item=>{
                const ss=STATUS_STYLES[item.status]||STATUS_STYLES.ok
                const sel=selectedItem?.id===item.id
                return (
                  <div key={item.id} onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                    style={{background:"white",borderRadius:8,padding:12,cursor:"pointer",
                      border:`2px solid ${sel?"#2563eb":item.alarm?"#fca5a5":"#e2e8f0"}`,
                      boxShadow:sel?"0 0 0 3px rgba(37,99,235,.12)":"0 1px 3px rgba(0,0,0,0.04)",transition:"all .15s"}}>
                    <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8",marginBottom:4}}>{item.id}</div>
                    <div style={{fontSize:11,fontWeight:700,color:"#374151",marginBottom:8,lineHeight:1.3}}>{item.name}</div>
                    <div style={{fontSize:20,fontWeight:800,color:"#374151",lineHeight:1}}>{item.qty} <span style={{fontSize:11,color:"#94a3b8",fontWeight:400}}>chiếc</span></div>
                    <div style={{fontSize:9,color:"#94a3b8",marginBottom:8}}>Sử dụng từ {item.since}</div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{background:ss.bg,color:ss.color,padding:"2px 7px",borderRadius:8,fontSize:9,fontWeight:600}}>{ss.label}</span>
                      {item.alarm&&<span style={{width:16,height:16,borderRadius:"50%",background:"#ef4444",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:8,color:"white",fontWeight:900}}>!</span>}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
        <div style={{width:268,background:"white",borderLeft:"1px solid #e2e8f0",flexShrink:0,overflowY:"auto"}}>
          {!selectedItem ? (
            <div style={{height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
              <span style={{fontSize:32}}>⚙</span>
              <span style={{fontWeight:600,color:"#64748b"}}>Chưa chọn đối tượng</span>
            </div>
          ) : (()=>{
            const item=selectedItem
            const ss=STATUS_STYLES[item.status]||STATUS_STYLES.ok
            const trend=Array.from({length:20},(_,i)=>20+Math.abs(Math.sin(i/3))*60+(Math.random()-.5)*10)
            return (
              <div>
                <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <div><span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span><span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.name}</span></div>
                  {item.alarm&&<span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"white",fontWeight:900}}>!</span>}
                </div>
                <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
                  {["Thông tin","Lịch sử","Cảnh báo"].map((t,i)=>(
                    <button key={t} style={{padding:"8px 10px",border:"none",cursor:"pointer",fontSize:11,fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"}}>{t}</button>
                  ))}
                </div>
                <div style={{padding:"14px",display:"flex",alignItems:"center",gap:10,background:"white",borderBottom:"1px solid #f1f5f9"}}>
                  <div style={{flex:1}}><div style={{fontSize:24,fontWeight:800,color:"#374151",lineHeight:1}}>{item.qty} <span style={{fontSize:13,fontWeight:400,color:"#94a3b8"}}>chiếc</span></div><div style={{fontSize:11,color:"#94a3b8",marginTop:2}}>Sử dụng từ {item.since}</div></div>
                  <span style={{background:ss.bg,color:ss.color,padding:"3px 10px",borderRadius:10,fontSize:10,fontWeight:600}}>{ss.label}</span>
                </div>
                {[["Mã máy",item.id],["Loại",item.type],["Số lượng",`${item.qty} chiếc`],["Ngày SD",item.since],["Trạng thái",ss.label],["Cảnh báo",item.alarm?"Có":"Không"]].map(([k,v])=>(
                  <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
                    <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
                    <span style={{fontSize:11,fontWeight:600,color:k==="Cảnh báo"&&item.alarm?"#ef4444":"#0f172a"}}>{v}</span>
                  </div>
                ))}
                <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
                <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
                  <div style={{display:"flex",alignItems:"flex-end",gap:1,height:52}}>
                    {trend.map((v,i)=>(
                      <div key={i} style={{flex:1,height:`${v}%`,background:item.alarm?"#ef4444":"#22c55e",borderRadius:"1px 1px 0 0",opacity:0.8}}/>
                    ))}
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
                    <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
                    <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
                  </div>
                </div>
              </div>
            )
          })()}
        </div>
      </div>
      </>
      )}
    </div>
  )
}

export default PXHQPanel
